import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAdmin } from '../../context/AdminContext';

const AdminHeader = ({ toggleSidebar }) => {
  const { admin, logout } = useAdmin();
  const navigate = useNavigate();
  
  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };
  
  return (
    <header className="admin-header py-2 px-4 d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center">
        {/* Mobile sidebar toggle button */}
        <button 
          className="btn btn-link text-light p-0 d-md-none me-3" 
          onClick={toggleSidebar}
        >
          <i className="fa fa-bars fs-5"></i>
        </button>
        
        <div className="breadcrumb-wrapper">
          {/* Responsive title that shows on mobile */}
          <h1 className="d-md-none h5 mb-0">
            <span className="text-gradient">SPONO Admin</span>
          </h1>
        </div>
      </div>
      
      <div className="header-actions d-flex align-items-center">
        {/* Notifications */}
        <div className="dropdown me-3">
          <button 
            className="btn btn-link text-light position-relative p-0" 
            data-bs-toggle="dropdown"
          >
            <i className="fa fa-bell fs-5"></i>
            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
              2
            </span>
          </button>
          <ul className="dropdown-menu dropdown-menu-end shadow-lg py-0" style={{minWidth: '320px'}}>
            <li>
              <div className="dropdown-header d-flex justify-content-between align-items-center">
                <span>Notifications</span>
                <a href="#" className="text-decoration-none small">Mark all as read</a>
              </div>
            </li>
            <li><hr className="dropdown-divider my-0"/></li>
            <li>
              <a className="dropdown-item p-3 border-bottom" href="#">
                <div className="d-flex">
                  <div className="flex-shrink-0">
                    <i className="fa fa-user-circle text-primary fs-4"></i>
                  </div>
                  <div className="ms-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="mb-0">New User Registration</h6>
                      <small className="text-muted">5 min ago</small>
                    </div>
                    <p className="text-muted mb-0 small">John Doe has registered as an event attendee</p>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a className="dropdown-item p-3" href="#">
                <div className="d-flex">
                  <div className="flex-shrink-0">
                    <i className="fa fa-calendar text-success fs-4"></i>
                  </div>
                  <div className="ms-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="mb-0">New Event Created</h6>
                      <small className="text-muted">1 hour ago</small>
                    </div>
                    <p className="text-muted mb-0 small">Summer Festival 2023 has been created</p>
                  </div>
                </div>
              </a>
            </li>
            <li><hr className="dropdown-divider my-0"/></li>
            <li>
              <a className="dropdown-item text-center p-2" href="#">
                <small>View All Notifications</small>
              </a>
            </li>
          </ul>
        </div>
        
        {/* User Menu */}
        <div className="dropdown">
          <button 
            className="btn btn-link p-0 d-flex align-items-center" 
            data-bs-toggle="dropdown"
          >
            <div className="avatar-circle me-2">
              <span className="initials">
                {admin?.name?.charAt(0) || 'A'}
              </span>
            </div>
            <span className="d-none d-md-inline text-light">{admin?.name || 'Admin'}</span>
            <i className="fa fa-caret-down ms-2 text-light"></i>
          </button>
          <ul className="dropdown-menu dropdown-menu-end shadow">
            <li>
              <div className="dropdown-header">
                <h6 className="mb-1">{admin?.name || 'Admin User'}</h6>
                <small className="text-muted">{admin?.email || 'admin@example.com'}</small>
              </div>
            </li>
            <li><hr className="dropdown-divider"/></li>
            <li>
              <Link className="dropdown-item" to="/admin/profile">
                <i className="fa fa-user me-2"></i>My Profile
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/admin/settings">
                <i className="fa fa-cog me-2"></i>Settings
              </Link>
            </li>
            <li><hr className="dropdown-divider"/></li>
            <li>
              <button className="dropdown-item" onClick={handleLogout}>
                <i className="fa fa-sign-out me-2"></i>Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
      
      <style jsx="true">{`
        .avatar-circle {
          width: 36px;
          height: 36px;
          background-color: #c93e67;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }
        
        .initials {
          font-size: 16px;
          font-weight: bold;
        }
        
        .text-gradient {
          background: linear-gradient(to right, #ff3636, #c93e67);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
        
        .admin-header {
          background-color: var(--dark-bg-secondary);
          border-bottom: 1px solid var(--dark-border);
          position: sticky;
          top: 0;
          z-index: 999;
        }
      `}</style>
    </header>
  );
};

export default AdminHeader;